<template>
  <draggable
      v-model="slideList"
      item-key="is_slide"
      @end="changeOrder"
      handle=".modBasicSecTitle"
  >
    <template #item="{ element, index }">
      <section class="lyMb16">

        <h2 class="modBasicSecTitle lyPt16 lyPb16">スライド{{ index+1 }}枚目</h2>
        <div class="modBasicSecContents">
          <div class="lyVerticalCnt lyHorizontalBw lyPd16">
            <p class="lyW10">
              <img :src="mediaBaseUrl+'/' +( element.thumbnail ? ('public_image/'+element.thumbnail+'?size=570_380') : 'images/columnDfltThumb.png')" alt="">
            </p>
            <p class="pFontBold lyW40" style="flex-grow: 1;margin-left: 16px">
              {{element.title}}
            </p>
          </div>
        </div>
      </section>

    </template>
  </draggable>

</template>

<script>
import {onMounted, ref} from 'vue';
import draggable from 'vuedraggable'

export default {
  components: {
    draggable: draggable
  },
  setup() {
    //ヘルプ一覧
    const slideList = ref([]);

    //状態 connecting
    const connecting = ref(false);

    //結果
    let successBox = ref(null);

    /**
     * Ajax 通信失敗時に起動させるメソッド
     */
    const _handleError = () => {
      //通信中フラグを false にする
      connecting.value = false;
    };
    /**
     * Ajax 中断時に起動させるメソッド
     */
    const _handleAbort = () => {
      //通信中フラグを false にする
      connecting.value = false;
    };
    /**
     * Ajax タイムアウトに起動させるメソッド
     */
    const _handleTimeout = () => {
      //通信中フラグを false にする
      connecting.value = false;

      };

    //サーバー通信 slideList を取得
    const _sync = () => {
      _serverConnect((data) => {
            slideList.value = data;
      },
          'get',
          getSlides_ep
      );
    };

    //サーバー通信 並び順変更
    const changeOrder = () => {
      const formData = new FormData();
      formData.append("slides", JSON.stringify(slideList.value));
      _serverConnect(() => {
            _showSuccess();
            _sync();
          },
          'post',
          changeSlideOrder_ep,
          formData
      );
    }

    //サーバーと通信する部分
    const _serverConnect = (onSuccess, openMethod, openUrl, sendBody = null) => {
      //通信中だったら何もしない
      if (connecting.value) {
        return Promise.reject();
      }

      //送信中フラグを on にする
      connecting.value = true;

      //非同期処理開始
      return new Promise((resolve, reject) => {
        //xhr を用意
        const xhr = new XMLHttpRequest();

        //通信失敗時
        xhr.addEventListener('error', () => {
          reject();
          _handleError();
        })
        xhr.addEventListener('timeout', () => {
          reject();
          _handleAbort();
        })
        xhr.addEventListener('abort', () => {
          reject();
          _handleTimeout();
        })

        //通信成功時処理
        xhr.addEventListener('load', event => {
          //送信中フラグを解除
          connecting.value = false;
          //成功・失敗のどちらでも response を JSON としてパースする
          let data = null;
          try {
            data = JSON.parse(event.target.response);
          }
          catch (e){
            console.log(e);
            // messages.value = ['エラーが発生しました。恐れ入りますが再度お試しください。'];
            reject();
            return;
          }
          //パースに失敗
          if (data === null) {
            reject();
            return;
          }
          //失敗判定
          if (event.target.status >= 400) {
            reject();
            return;
          }

          //成功したら結果を描写
          onSuccess(data);
        });

        //通信を試みる
        xhr.open(openMethod, openUrl);
        xhr.setRequestHeader('X-CSRF-Token', tokenValue)
        xhr.send(sendBody);
      });
    }

    //更新に成功したtoastを表示
    const _showSuccess = () => {
      if (successBox.value && !successBox.value.classList.contains('isDsply')) {
        successBox.value.classList.add('isDsply');
        successBox.value.style.display = 'block';
        successBox.value.style.zIndex = 9999;
        setTimeout(() => { successBox.value.classList.remove('isDsply') }, 1500);
      }
    }

    onMounted(() => {
      if (document.getElementsByClassName('js-successToast')) {
        successBox.value = document.getElementsByClassName('js-successToast')[0];
      }

      //init
      _sync();
    });

    return {
      tokenValue,
      mediaBaseUrl,
      getSlides_ep,
      changeSlideOrder_ep,
      slideList,
      changeOrder,
    };
  },
}

</script>
